import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  fetchCouponSummary,
  fetchPrimSummary,
  fetchServiceCommissionSummary,
} from "../../../slices/apps/companySlice";

// Sayfaya özel stiller.
const ModernStyles = () => (
  <style>{`
    .nav-tabs-modern {
      border-bottom: 2px solid #f0f0f0;
      }
      .nav-tabs-modern .nav-link {
        border: none;
        color: #878a99;
        font-weight: 600;
        padding: 1rem;
        }
        .nav-tabs-modern .nav-link.active {
          color: var(--bs-primary);
          background-color: transparent;
          border-bottom: 2px solid var(--bs-primary);
          }
          .table thead {
            background-color: #f8f9fa;
            }
            `}</style>
);

// sayfalar, modallar vs.
import RequestPaymentTable from "./RequestPaymentTable";
import CouponPaymentTable from "./CouponPaymentTable";
import PrimPaymentTable from "./PrimPaymentTable";
import Widgets from "./Widgets";

const AdminDashboard = () => {
  document.title = "Ana Sayfa | Metiner Avantaj+";

  const dispatch = useDispatch();

  const { requestPaymentsRefresh, couponPaymentsRefresh, primPaymentsRefresh } =
    useSelector((state) => {
      return {
        requestPaymentsRefresh: state.order.requestPaymentsRefresh,
        couponPaymentsRefresh: state.order.couponPaymentsRefresh,
        primPaymentsRefresh: state.order.primPaymentsRefresh,
      };
    }, shallowEqual);

  // states
  const [loading, setLoading] = useState(true);

  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => activeTab !== tab && setActiveTab(tab);

  const fetchData = async () => {
    setLoading(true);

    try {
      await dispatch(fetchServiceCommissionSummary()).unwrap();
      await dispatch(fetchCouponSummary()).unwrap();
      await dispatch(fetchPrimSummary()).unwrap();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    dispatch,
    requestPaymentsRefresh,
    couponPaymentsRefresh,
    primPaymentsRefresh,
  ]);

  if (loading) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "50vh" }}
            >
              <Spinner color="primary">Yükleniyor...</Spinner>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <ModernStyles />
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Row className="gy-3">
                  <Col xxl="12">
                    <Card>
                      <CardBody>
                        <Nav tabs className="nav-tabs-modern">
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => toggleTab("1")}
                              style={{ cursor: "pointer" }}
                            >
                              Ciro Primi
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "2",
                              })}
                              onClick={() => toggleTab("2")}
                              style={{ cursor: "pointer" }}
                            >
                              Kupon Hak Ediş
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: activeTab === "3",
                              })}
                              onClick={() => toggleTab("3")}
                              style={{ cursor: "pointer" }}
                            >
                              Kayıt Primi
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </CardBody>
                    </Card>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1">
                        <Row className="gy-3">
                          <Col xxl="12">
                            <Widgets tabType="ciro" />
                          </Col>
                          <Col xxl="12">
                            <RequestPaymentTable />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <Row className="gy-3">
                          <Col xxl="12">
                            <Widgets tabType="coupon" />
                          </Col>
                          <Col xxl="12">
                            <CouponPaymentTable />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="3">
                        <Row className="gy-3">
                          <Col xxl="12">
                            <Widgets tabType="prim" />
                          </Col>
                          <Col xxl="12">
                            <PrimPaymentTable />
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AdminDashboard;
